import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./Login"
import Dashboard from './dashboard/Index'
import DashboardSPV from './dashboard/supervisor/Index.js'
import PrivateRoute from '../routes/PrivateRoute'

import DashboardPlanner from './dashboard/planner/Index.js'
import {connect, Provider} from 'react-redux'
import ErrorPage from './ErrorPage'
import ProtectedRoute from '../routes/ProtectedRoute'
import { postLoginRequest } from "../redux/actions/loginAction";


const TaskManagement = ({isAuthenticated}) => {
  return (
    <>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route
          exact
          path="/dashboard"
          component={Dashboard}
        />
        <Route path="/dashboard/supervisor" component={DashboardSPV} />
        <Route path="/dashboard/planner" component={DashboardPlanner} />
        <Route path="*" component={ErrorPage} />
      </Switch>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.login.isAuthenticated,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     postLoginRequest: (setAuth) => dispatch(postLoginRequest(setAuth)),
//   };
// };


export default connect(mapStateToProps, null)(TaskManagement);
